// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v0-0";
export var checkoutRateBadgeLink = "_v0-1";